import React from 'react';
import Logo_w from '../images/logomenu_w.png'
import Logo_b from '../images/logomenu_b.png'
import {ReactComponent as AddMenuIcon} from '../svgs/add_menu.svg'
import {ReactComponent as RoomIcon} from '../svgs/room.svg'
import {ReactComponent as LoadingIcon} from '../svgs/loading.svg'
import {ReactComponent as CategoryIcon} from '../svgs/category.svg'
import localization from '../lib/localization/localization';

export default function MenuElement({menu, elfield, room_click, category_click, addMenu, ui_language, weath_data}){

    let chose_room_id
    let chose_category_id
    let menu_room_content = ''
    let menu_category_content = ''

    let weather_div = (<div className="menu_weather">
        <LoadingIcon className="menu_weather_icon_download" />
        </div>)
  
    if(weath_data){
        let src_weather_icon = "/images/weather_icons/"+weath_data.weather_state_abbr+".png"
        let weath_temp 
        if (weath_data.the_temp) weath_temp = weath_data.the_temp.toFixed(1)
        weather_div = (
            <div className="menu_weather">
                <div className="menu_weather_temp">{weath_temp}°C</div>
                <img className="menu_weather_icon" src={src_weather_icon}></img>
            </div>)
    }

    if (elfield.field_type === 'room') chose_room_id = elfield.field_id
    
    if(menu[0]){
        menu_room_content = menu[0].map( menu_element => {
            if (menu_element.ui_room_id === chose_room_id) {
                return <div className={'menu_item_chose'} onClick={()=> room_click(menu_element.ui_room_id)}> {menu_element.ui_room_name}</div>
            }
            else return <div className={'menu_item'} onClick={()=> room_click(menu_element.ui_room_id)}> {menu_element.ui_room_name}</div>
        })
    }

    if (elfield.field_type === 'category') chose_category_id = elfield.field_id
    
    if(menu[1]){
        menu_category_content = menu[1].map( menu_element => {
            if (menu_element.ui_category_id === chose_category_id) {
                return <div className={'menu_item_chose'} onClick={()=> category_click(menu_element.ui_category_id)}> {menu_element.ui_category_name}</div>
            }
            else return <div className={'menu_item'} onClick={()=> category_click(menu_element.ui_category_id)}> {menu_element.ui_category_name}</div>
        })
    }
    //<img src={Logo_w} height='100%'/>

    return(
        <div>
            <script type="text/javascript" src="https://widgets-viewer.climacell.co/v1/sdk.js"></script>
            <div className="menu_weather_color"></div>
            <div className="menu_logo">CONNECT</div>
            {weather_div}
            <div className="menu_scroll">
                <div className="menu_heading"><RoomIcon className="menu_img"/>{localization.localize(ui_language).room}</div>
                {menu_room_content}
                <br></br>
                <div className="menu_heading"><CategoryIcon className="menu_img"/>{localization.localize(ui_language).category}</div>
                {menu_category_content}
            </div>
            <div className="add_menu" onClick={() => addMenu()}> <AddMenuIcon className="add_img"/> </div>
        </div>
    )
}